import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fileContentDialog',
  templateUrl: './fileContentDialog.component.html',
  styleUrls: ['./fileContentDialog.component.css']
})
export class FileContentDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<FileContentDialogComponent>) {}

  content: string;

  ngOnInit() {}
}
